//import React from "react";
import App from "./App";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ToastProvider } from "./components/toast/toastPrivider";
import { SpinnerProvider } from "./components/spinner/spinnerProvider";
import { GoogleOAuthProvider } from "@react-oauth/google";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./index.scss";

ReactDOM.createRoot(document.getElementById("root")!).render(
  //<React.StrictMode>
    <BrowserRouter>
        <ToastProvider>
          <SpinnerProvider>
            <GoogleOAuthProvider clientId={import.meta.env.VITE_GOOGLE_CLIENT_ID}>
            <App />
            </GoogleOAuthProvider>
          </SpinnerProvider>
      </ToastProvider>
    </BrowserRouter>
  //</React.StrictMode>
);
